import { ElNotification } from 'element-plus';
import { i18n } from '@/bootstrap';

export default () => ElNotification.error({
  title: i18n.global.t('toast_message.global_fail.title'),
  message: i18n.global.t('toast_message.global_fail.text'),
});
